// extracted by mini-css-extract-plugin
export var category = "Ratings-module--category--0dcec";
export var categoryCards = "Ratings-module--categoryCards--66765";
export var categoryHeading = "Ratings-module--categoryHeading--49f89";
export var container = "Ratings-module--container--9c70a";